/**
 * Created by Karan variya on 24/12/2018.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { SubscriptionReportComponent } from './subscriptionreport.page';
export const routes: Routes = [
    { path: 'subscriptionreport', component: SubscriptionReportComponent }
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [SubscriptionReportComponent]
})
export class SubscriptionReportModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/subscriptionreport/subscriptionreport.module.ts